import type { Field } from './field';
import type { TagWithCount, TemplateTag } from './tag';
import type { TemplateVariant } from './variant';

export interface TemplateListResponse {
    totalCount: number;
    draftCount: number;
    count: number;
    next: string | null;
    previous: string | null;
    results: TemplateListItem[];
    recentDrafts: TemplateListItem[];
    tags: TagWithCount[];
    draftTags: TagWithCount[];
}

export interface TemplateListItem {
    id: number;
    name: string;
    uuid: string;
    organization: number;
    createdBy: number;
    createdAt: string;
    variantCount: number;
    latestVersion: TemplateVersion;
    publishedVersion: TemplateVersion;
    tags: TemplateTag[];
}

export interface TemplateVersion {
    id: number;
    template: number;
    thumbnail: string;
    fields: Field[];
    isEdited: boolean;
    publishedAt: string | null;
    variants: TemplateVariant[];
}

export interface TemplateDetails {
    id: number;
    name: string;
    uuid: string;
    organization: number;
    thumbnail: string;
    tags: TemplateTag[];
    variants: TemplateVariant[];
    latestVersion: TemplateVersion;
    publishedVersion: TemplateVersion;
    createdBy: number;
}

export interface TemplateQuery {
    sort?: string;
    draft?: boolean;
    tag?: number;
}
